import { Loader } from 'components/dashboard/styles';

type ConditionalStateProps = {
  condition: boolean;
  placeholder?: React.ReactNode;
  children?: React.ReactNode;
};

export const ConditionalState = ({
  condition,
  placeholder,
  children,
}: ConditionalStateProps): JSX.Element | null => {
  if (condition) {
    return placeholder !== undefined ? <>{placeholder}</> : <Loader />;
  }

  return children !== undefined ? <>{children}</> : null;
};
